<script lang="ts">
	import type { Post } from '$lib/posts';
	import PostCard from '$lib/components/post-card.svelte';

	export let posts: Post[];
</script>

<ul>
	{#each posts as post}
		<li class="py-5 border-b last:border-none border-border">
			<PostCard {post} />
		</li>
	{/each}
</ul>
